// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"309":"b8cb5835","477":"7e9d80ca"}[chunkId] + ".chunk.css";
};